import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { Box } from '@mui/system';
import { Form, FormStatus } from 'api/models';
import { mutation, remove } from 'operations';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import { getFields } from 'routes/Form/utils';
import { dialogState, formTemplateState } from 'state';
import { GeneralIds, ModelTypes } from 'types/types';

export default function FormConfirmationDialog(): JSX.Element {
  const [{ data }, closeDialog] = useRecoilState(dialogState);
  const { visitId, formId } = useParams<GeneralIds>();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const formTemplate = useRecoilValue(formTemplateState);

  const onSave = async () => {
    setLoading(true);
    await mutation<Form>({
      type: ModelTypes.form,
      body: {
        id: formId ?? '',
        status: FormStatus.Filling,
        formTemplateId: formTemplate?.id ?? '',
        fields: getFields(
          data.values,
          formTemplate?.fieldTemplates ?? [],
          formTemplate?.layout.items ?? [],
        ),
      },
      ids: {
        visitId,
        id: formId ?? '',
      },
    });
    setLoading(false);
  };

  return (
    <Box>
      <DialogTitle>{t('dialogs.formConfirmationDialog.title')}</DialogTitle>
      <DialogContent></DialogContent>
      <DialogActions>
        <Button
          disabled={loading}
          onClick={async () => {
            data.blocker.proceed();
            if (data.formId) {
              await remove({
                type: ModelTypes.form,
                ids: {
                  id: data.formId,
                  visitId,
                },
              });
            }
            closeDialog({
              isOpen: false,
            });
          }}
          color="secondary"
          variant="contained"
          sx={{ mb: 1 }}
        >
          {t('dialogs.formConfirmationDialog.cancelButtonTitle')}
        </Button>
        <Button
          disabled={loading}
          type="submit"
          color="primary"
          variant="contained"
          sx={{ mr: 2, mb: 1 }}
          onClick={async () => {
            data.blocker.proceed();
            await onSave();

            closeDialog({
              isOpen: false,
            });
          }}
        >
          {loading
            ? t('dialogs.formConfirmationDialog.confirmButtonTitle')
            : t('dialogs.formConfirmationDialog.confirmButtonTitle')}
        </Button>
      </DialogActions>
    </Box>
  );
}
